import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const inspectionReportService = {
    getAllInspectionReports,
    getInspectionReport,
};

const MODULE = {
    REPORT: 'inspection-reports',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllInspectionReports(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.REPORT}`, requestOptions)
}

export function getInspectionReport(id) {
    return apiHelper(API_URL).get(`/${MODULE.REPORT}/${id}`)
}